export default __webpack_public_path__ + "static/media/Greece.4492f1b9.svg";